import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";
import RolesApi from '../../Services/Roles';
import Alert from '../../Services/Alert';

/* Add / edit a role. Route /roles/add (no id) or /roles/edit/:id. */
export const RoleForm = (props) => {
    const id = props.match.params.id || null;
    const isEdit = !!id;

    const [name, setName] = useState('');
    const [modules, setModules] = useState([]);   // [{key,label}]
    const [actions, setActions] = useState(['read', 'write', 'delete']);
    const [perms, setPerms] = useState({});        // { module: {read,write,delete} }
    const [isSystem, setIsSystem] = useState(false);

    /* Load the catalogue first, then (when editing) overlay the saved role. */
    useEffect(() => {
        RolesApi.modules().then(resp => {
            const r = resp.data;
            if (r.status != 1) { Alert.error(r.message); return; }
            setModules(r.data.modules);
            setActions(r.data.actions);
            const blank = {};
            r.data.modules.forEach(m => { blank[m.key] = { read: false, write: false, delete: false }; });

            if (isEdit) {
                RolesApi.get(id).then(rr => {
                    const d = rr.data;
                    if (d.status != 1) { Alert.error(d.message); return; }
                    setName(d.data.name);
                    setIsSystem(!!d.data.is_system);
                    setPerms({ ...blank, ...(d.data.permissions || {}) });
                }).catch(e => Alert.error(e.message));
            } else {
                setPerms(blank);
            }
        }).catch(e => Alert.error(e.message));
    }, [id]);

    function toggle(moduleKey, action) {
        setPerms(prev => ({
            ...prev,
            [moduleKey]: { ...prev[moduleKey], [action]: !prev[moduleKey]?.[action] },
        }));
    }

    function toggleRow(moduleKey, value) {
        const row = {};
        actions.forEach(a => { row[a] = value; });
        setPerms(prev => ({ ...prev, [moduleKey]: row }));
    }

    function onSubmit(e) {
        e.preventDefault();
        if (!name.trim()) { Alert.error('Role name is required'); return; }
        const payload = { name: name.trim(), permissions: perms };
        const call = isEdit ? RolesApi.update({ id, ...payload }) : RolesApi.create(payload);
        call.then(res => res.data).then(res => {
            if (res.status) { Alert.success(res.message); props.history.push('/roles'); }
            else Alert.error(res.message);
        }).catch(e => Alert.error(e.message));
    }

    return (
        <section className="main-content marketadd_main_sec">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title mb-4">{isEdit ? 'Edit Role' : 'Add Role'}</h4>
                                    <form onSubmit={onSubmit}>
                                        <div className="mb-3 col-lg-4">
                                            <label className="form-label">Role Name</label>
                                            <input type="text" className="form-control" value={name}
                                                onChange={e => setName(e.target.value)} placeholder="e.g. Results Operator" />
                                        </div>

                                        <label className="form-label mt-2">Permissions</label>
                                        <div className="table-responsive">
                                            <table className="table table-bordered align-middle mb-0">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Module</th>
                                                        {actions.map(a => <th key={a} className="text-center text-capitalize">{a}</th>)}
                                                        <th className="text-center">All</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {modules.map(m => {
                                                        const row = perms[m.key] || {};
                                                        const allOn = actions.every(a => row[a]);
                                                        return (
                                                            <tr key={m.key}>
                                                                <td>{m.label}</td>
                                                                {actions.map(a => (
                                                                    <td key={a} className="text-center">
                                                                        <input type="checkbox" checked={!!row[a]}
                                                                            onChange={() => toggle(m.key, a)} />
                                                                    </td>
                                                                ))}
                                                                <td className="text-center">
                                                                    <input type="checkbox" checked={allOn}
                                                                        onChange={() => toggleRow(m.key, !allOn)} />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="mt-4">
                                            <button type="submit" className="btn btn-primary me-2">{isEdit ? 'Update' : 'Create'}</button>
                                            <button type="button" className="btn btn-light" onClick={() => props.history.push('/roles')}>Cancel</button>
                                        </div>
                                        {isSystem ? <p className="text-muted mt-2 mb-0"><small>This is a system role.</small></p> : null}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default withRouter(RoleForm);
